<template>
  <div>
    <v-row class="mb-4" v-if="showFilters">
      <v-col cols="12" md="4">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="selectedDate"
              label="Tarih"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="selectedDate"
            @input="dateMenu = false; fetchLogs()"
            locale="tr"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="4" v-if="!fixedOrderNo">
        <v-text-field
          v-model="searchTerm"
          label="Arama"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" :md="fixedOrderNo ? 8 : 4">
        <v-btn color="primary" @click="fetchLogs" block>
          <v-icon left>mdi-refresh</v-icon>
          Yenile
        </v-btn>
      </v-col>
    </v-row>

    <v-chip v-if="fixedOrderNo" class="mb-3" color="indigo" dark small>
      Sipariş No: {{ fixedOrderNo }}
    </v-chip>

    <v-data-table
      :headers="headers"
      :items="filteredLogs"
      :loading="loading"
      :items-per-page="itemsPerPage"
      class="elevation-1"
      :footer-props="{
        itemsPerPageText: 'Sayfa başına kayıt:',
        itemsPerPageAllText: 'Tümü',
        nextText: 'Sonraki',
        prevText: 'Önceki'
      }"
    >
      <template v-slot:item.creationTime="{ item }">
        <span>{{ formatDate(item.creationTime) }}</span>
      </template>

      <template v-slot:item.methodName="{ item }">
        <v-chip :color="getMethodColor(item.methodName)" dark small>
          {{ item.methodName }}
        </v-chip>
      </template>

      <template v-slot:item.orderNo="{ item }">
        <span class="font-weight-bold">{{ item.orderNo }}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip :color="getStatusColor(item)" dark small>
          {{ getRequestStatus(item) }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon small @click="showLogDetails(item)" color="primary">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-expand-transition>
      <v-card v-if="embedded && detailDialog && selectedLog" class="mt-3 log-detail-card" outlined>
        <v-card-title class="py-2">
          <span class="subtitle-1 font-weight-medium">Request Log Detayı</span>
          <v-spacer></v-spacer>
          <v-btn icon small @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Zaman"
                :value="formatDate(selectedLog.creationTime)"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Method"
                :value="selectedLog.methodName"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Order No"
                :value="selectedLog.orderNo"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Durum"
                :value="getRequestStatus(selectedLog)"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Order ID"
                :value="selectedLog.orderId"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Request"
                :value="formatJson(selectedLog.request)"
                readonly
                outlined
                auto-grow
                rows="6"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Response"
                :value="formatJson(selectedLog.response)"
                readonly
                outlined
                auto-grow
                rows="6"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-expand-transition>

    <v-dialog
      v-if="!embedded"
      v-model="detailDialog"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Request Log Detayı</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text v-if="selectedLog">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Zaman"
                :value="formatDate(selectedLog.creationTime)"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Method"
                :value="selectedLog.methodName"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Order No"
                :value="selectedLog.orderNo"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Durum"
                :value="getRequestStatus(selectedLog)"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Order ID"
                :value="selectedLog.orderId"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Request"
                :value="formatJson(selectedLog.request)"
                readonly
                outlined
                auto-grow
                rows="10"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Response"
                :value="formatJson(selectedLog.response)"
                readonly
                outlined
                auto-grow
                rows="10"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ajax from '@/lib/ajax';

export default {
  name: 'ServiceLogsPanel',
  props: {
    fixedOrderNo: {
      type: String,
      default: null
    },
    initialDate: {
      type: String,
      default: null
    },
    showFilters: {
      type: Boolean,
      default: true
    },
    itemsPerPage: {
      type: Number,
      default: 100
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchTerm: '',
      selectedDate: this.initialDate || new Date().toISOString().substring(0, 10),
      dateMenu: false,
      loading: false,
      detailDialog: false,
      selectedLog: null,
      headers: [
        { text: 'Order No', value: 'orderNo', width: '120px' },
        { text: 'Method', value: 'methodName', width: '150px' },
        { text: 'Tarih', value: 'creationTime', width: '180px' },
        { text: 'Durum', value: 'status', width: '120px' },
        { text: 'İşlemler', value: 'actions', sortable: false, width: '100px' }
      ],
      logs: []
    };
  },
  computed: {
    filteredLogs() {
      let filtered = this.logs;

      if (this.fixedOrderNo) {
        const orderNo = String(this.fixedOrderNo).toLowerCase();
        filtered = filtered.filter(
          (log) => String(log.orderNo).toLowerCase() === orderNo
        );
      } else if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        filtered = filtered.filter(
          (log) =>
            String(log.orderNo).toLowerCase().includes(term) ||
            String(log.orderId).toLowerCase().includes(term) ||
            String(log.methodName).toLowerCase().includes(term)
        );
      }

      return filtered.sort(
        (a, b) => new Date(b.creationTime) - new Date(a.creationTime)
      );
    }
  },
  watch: {
    initialDate(val) {
      if (val) {
        this.selectedDate = val;
      }
    }
  },
  async mounted() {
    await this.fetchLogs();
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    getMethodColor(methodName) {
      switch (methodName) {
        case 'EgesenBook':
          return 'green darken-2';
        case 'TuiBook':
          return 'blue darken-2';
        case 'SelfieBook':
          return 'orange darken-2';
        case 'EgesenSearch':
          return 'teal darken-2';
        case 'TuiSearch':
          return 'indigo darken-2';
        case 'WegoSearch':
          return 'purple darken-2';
        case 'WegoBook':
          return 'deep-purple darken-2';
        default:
          return 'blue-grey darken-2';
      }
    },
    tryParseLogResponse(log) {
      const raw = log.response;
      if (raw == null || raw === '') {
        return { ok: false, raw: '' };
      }
      if (typeof raw === 'object') {
        return { ok: true, data: this.deepUnwrapJsonStrings(raw) };
      }
      const trimmed = String(raw).trim();
      if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) {
        return { ok: false, raw: trimmed };
      }
      try {
        let parsed = JSON.parse(trimmed);
        if (typeof parsed === 'string') {
          const inner = parsed.trim();
          if (inner[0] === '{' || inner[0] === '[') {
            parsed = JSON.parse(inner);
          } else {
            return { ok: false, raw: parsed };
          }
        }
        if (typeof parsed !== 'object' || parsed === null) {
          return { ok: false, raw: trimmed };
        }
        return { ok: true, data: this.deepUnwrapJsonStrings(parsed) };
      } catch {
        return { ok: false, raw: trimmed };
      }
    },
    isPlainTextErrorLog(log, plainText = '') {
      const combined = `${plainText}\n${log.request || ''}`.toLowerCase();
      const errorPatterns = [
        'idempotency hit',
        'existing tuiorder',
        'existing order'
      ];
      return errorPatterns.some((pattern) => combined.includes(pattern));
    },
    getTicketsBronFromResponse(response) {
      if (response.Tickets_BRON) {
        return response.Tickets_BRON;
      }
      const content = response.content;
      if (!content || typeof content !== 'object') {
        return null;
      }
      if (content.Tickets_BRON) {
        return content.Tickets_BRON;
      }
      return null;
    },
    hasTicketsBronClaimAndPrice(ticketsBron) {
      if (!ticketsBron || typeof ticketsBron !== 'object') {
        return false;
      }
      const hasClaim = ticketsBron.claim != null && ticketsBron.claim !== '';
      const hasPrice = ticketsBron.price != null && ticketsBron.price !== '';
      return hasClaim && hasPrice;
    },
    isBronEnvelopeResponse(response) {
      return (
        response.statusCode != null &&
        response.content != null &&
        typeof response.content === 'object'
      );
    },
    getRequestStatus(log) {
      try {
        if (this.isPlainTextErrorLog(log)) {
          return 'HATA';
        }

        const parsed = this.tryParseLogResponse(log);
        if (!parsed.ok) {
          return 'HATA';
        }

        const response = parsed.data;

        if (response.error) {
          return 'HATA';
        }

        if (response.result && response.result.books) {
          return 'BAŞARILI';
        }

        if (this.isBronEnvelopeResponse(response) || response.Tickets_BRON) {
          const ticketsBron = this.getTicketsBronFromResponse(response);
          if (!ticketsBron) {
            return 'HATA';
          }
          if (ticketsBron.error) {
            return 'HATA';
          }
          return this.hasTicketsBronClaimAndPrice(ticketsBron)
            ? 'BAŞARILI'
            : 'HATA';
        }

        if (response.audit && !response.error) {
          return 'BAŞARILI';
        }

        if (response.statusCode != null && response.statusCode !== 200) {
          return 'HATA';
        }

        return 'BILINMIYOR';
      } catch (e) {
        return 'HATA';
      }
    },
    getStatusColor(log) {
      const status = this.getRequestStatus(log);
      switch (status) {
        case 'BAŞARILI':
          return 'green darken-2';
        case 'HATA':
          return 'red darken-2';
        default:
          return 'blue-grey darken-2';
      }
    },
    decodeJsonUnicodeEscapes(str) {
      if (str == null || typeof str !== 'string') {
        return str;
      }
      return str
        .replace(
          /\\u([dD][89abAB][\da-fA-F]{2})\\u([dD][c-fC-F][\da-fA-F]{2})/g,
          (_, hi, lo) => {
            const cp =
              (parseInt(hi, 16) - 0xd800) * 0x400 +
              parseInt(lo, 16) -
              0xdc00 +
              0x10000;
            return String.fromCodePoint(cp);
          }
        )
        .replace(/\\u([\da-fA-F]{4})/g, (_, hex) =>
          String.fromCharCode(parseInt(hex, 16))
        );
    },
    tryParseNestedJsonString(s) {
      if (typeof s !== 'string') {
        return s;
      }
      const t = s.trim();
      if (!t || (t[0] !== '{' && t[0] !== '[')) {
        return s;
      }
      try {
        return JSON.parse(s);
      } catch {
        return s;
      }
    },
    deepUnwrapJsonStrings(value, depth = 0) {
      if (depth > 12 || value === null || value === undefined) {
        return value;
      }
      if (Array.isArray(value)) {
        return value.map((v) => this.deepUnwrapJsonStrings(v, depth + 1));
      }
      if (typeof value === 'object') {
        const out = {};
        for (const k of Object.keys(value)) {
          let v = value[k];
          if (typeof v === 'string') {
            const parsed = this.tryParseNestedJsonString(v);
            v =
              parsed !== v
                ? this.deepUnwrapJsonStrings(parsed, depth + 1)
                : v;
          } else {
            v = this.deepUnwrapJsonStrings(v, depth + 1);
          }
          out[k] = v;
        }
        return out;
      }
      return value;
    },
    formatJson(jsonString) {
      if (jsonString == null || jsonString === '') {
        return '';
      }
      let parsed;
      try {
        parsed =
          typeof jsonString === 'object' ? jsonString : JSON.parse(jsonString);
      } catch (e) {
        return this.decodeJsonUnicodeEscapes(String(jsonString));
      }
      try {
        const unwrapped = this.deepUnwrapJsonStrings(parsed);
        const pretty = JSON.stringify(unwrapped, null, 2);
        return this.decodeJsonUnicodeEscapes(pretty);
      } catch (e) {
        return this.decodeJsonUnicodeEscapes(String(jsonString));
      }
    },
    showLogDetails(log) {
      this.selectedLog = log;
      this.detailDialog = true;
    },
    async fetchLogs() {
      this.loading = true;
      try {
        const response = await ajax.get(
          `/api/services/app/Admin/GetRequestLogs?Date=${this.selectedDate}`
        );
        const data = response.data;

        if (data.success) {
          this.logs = data.result.items;
        } else {
          this.$toast.error('Loglar yüklenirken hata oluştu');
        }
      } catch (error) {
        console.error('Error fetching logs:', error);
        this.$toast.error('Loglar yüklenirken hata oluştu');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
